import { Filter } from '@app/pcs/models';
import { Action } from '@ngrx/store/src/models';

export enum FilterEditActionTypes {
  InitFilterForm = '[FilterEdit] Init Filter Form',
  ResetForm = '[FilterEdit] Reset Form'
}

export class InitFilterForm implements Action {
  readonly type = FilterEditActionTypes.InitFilterForm;

  constructor(public payload: Filter) {
  }
}

export class ResetForm implements Action {
  readonly type = FilterEditActionTypes.ResetForm;
}

export type FilterEditActions =
  | InitFilterForm
  | ResetForm;
